
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/kaoguan/options',
  kaoguanManageList: '/adminapi/kaoguan/kaoguanManageList',
  manageDetail: '/adminapi/kaoguan/manageDetail',
  editManage: '/adminapi/kaoguan/editManage',
  memberList: '/adminapi/kaoguan/memberList',
  memberDetail: '/adminapi/kaoguan/memberDetail',
  memberEdit: '/adminapi/kaoguan/memberEdit',
  manageDelete: '/adminapi/kaoguan/manageDelete',
  memberDelete: '/adminapi/kaoguan/memberDelete',
  memberImport: '/adminapi/kaoguan/memberImport',
  shenheUrls: '/adminapi/kaoguan/shenheUrls',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}

export function kaoguanManageList(parameter) {
  return axios({
    url: api.kaoguanManageList,
    method: 'get',
    params: parameter
  })
}
export function manageDetail(parameter) {
  return axios({
    url: api.manageDetail,
    method: 'get',
    params: parameter
  })
}

export function editManage(parameter) {
  return axios({
    url: api.editManage,
    method: 'post',
    data: parameter
  })
}

export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}
export function memberImport(parameter) {
  return axios({
    url: api.memberImport,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}

export function applyDelete(parameter) {
  return axios({
    url: api.manageDelete,
    method: 'get',
    params: parameter
  })
}

export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}

export function getShenheUrls(parameter) {
  return axios({
    url: api.shenheUrls,
    method: 'get',
    params: parameter
  })
}

